import React, { useState } from 'react';
import opportunities from '../../cms/opportunities.json';
import pageIntros from '../../cms/page-intros.json';
import PageChrome from '../../components/layout/PageChrome';
import InternshipOpportunityCard from '../../components/cards/InternshipOpportunityCard';
import RichText from '../../components/ui/RichText';
import { FaExternalLinkAlt, FaArrowRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import '../../css/student-life/InternshipOpportunities.css';

const intro = pageIntros.internship || {};

const InternshipOpportunities = () => {
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);
  const navigate = useNavigate();

  const closeModal = () => {
    setSelectedOpportunity(null);
  };

  const handleViewFellowships = () => {
    closeModal();
    navigate('/jewish-learning');
  };

  return (
    <>
      <PageChrome
        title={intro.title}
        subtitle={intro.subtitle}
        sectionTitle={intro.sectionTitle}
        intro={intro.intro}
      >
        <section className="internship-opportunities-page-section">
          <div className="internship-opportunities-page-grid">
            {opportunities.map((opportunity, index) => (
              <div 
                key={index}
                className="internship-opportunities-page-card-wrapper"
              >
                <InternshipOpportunityCard 
                  opportunity={opportunity}
                  onClick={() => setSelectedOpportunity(opportunity)}
                />
              </div>
            ))}
          </div>
        </section>
      </PageChrome>

      {/* Internship Opportunities Modal */}
      {selectedOpportunity && (
        <div className="internship-opportunities-modal-overlay" onClick={closeModal}>
          <div className="internship-opportunities-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="internship-opportunities-modal-close" onClick={closeModal}>×</button>
            <div className="internship-opportunities-modal-header">
              <h2 className="internship-opportunities-modal-title">{selectedOpportunity.name}</h2>
              <RichText value={selectedOpportunity.description} className="internship-opportunities-modal-subtitle" />
            </div>
            <div className="internship-opportunities-modal-body">
              <div className="internship-opportunities-modal-details">
                <div className="internship-opportunities-modal-detail">
                  <span className="internship-opportunities-modal-detail-label">Duration:</span>
                  <span className="internship-opportunities-modal-detail-value">{selectedOpportunity.duration}</span>
                </div>
                <div className="internship-opportunities-modal-detail">
                  <span className="internship-opportunities-modal-detail-label">Stipend:</span>
                  <span className="internship-opportunities-modal-detail-value">{selectedOpportunity.stipend}</span>
                </div>
                <div className="internship-opportunities-modal-detail">
                  <span className="internship-opportunities-modal-detail-label">Contact:</span>
                  <span className="internship-opportunities-modal-detail-value">
                    <a href={`mailto:${selectedOpportunity.contact.email}`}>
                      {selectedOpportunity.contact.name}
                    </a>
                  </span>
                </div>
              </div>

              {selectedOpportunity.highlights && (
                <div className="internship-opportunities-modal-section">
                  <h4 className="internship-opportunities-modal-section-title">Highlights</h4>
                  <ul className="internship-opportunities-modal-highlights">
                    {selectedOpportunity.highlights.map((highlight, index) => (
                      <li key={index}>{highlight}</li>
                    ))}
                  </ul>
                </div>
              )}

              {selectedOpportunity.requirements && (
                <div className="internship-opportunities-modal-section">
                  <h4 className="internship-opportunities-modal-section-title">Requirements</h4>
                  <ul className="internship-opportunities-modal-requirements">
                    {selectedOpportunity.requirements.map((requirement, index) => (
                      <li key={index}>{requirement}</li>
                    ))}
                  </ul>
                </div>
              )}

              {selectedOpportunity.benefits && (
                <div className="internship-opportunities-modal-section">
                  <h4 className="internship-opportunities-modal-section-title">Benefits</h4>
                  <ul className="internship-opportunities-modal-benefits">
                    {selectedOpportunity.benefits.map((benefit, index) => (
                      <li key={index}>{benefit}</li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="internship-opportunities-modal-application">
                {selectedOpportunity.name === 'Learning Fellowships' ? (
                  <div className="internship-opportunities-modal-application">
                    <button
                      onClick={handleViewFellowships}
                      className="internship-opportunities-modal-view-fellowships-link"
                    >
                      View Fellowships <FaArrowRight />
                    </button>
                  </div>
                ) : selectedOpportunity.applicationStatus === 'open' ? (
                  <div className="internship-opportunities-modal-application">
                    {selectedOpportunity.applicationLink ? (
                      <a 
                        href={selectedOpportunity.applicationLink} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="internship-opportunities-modal-application-link"
                      >
                        Apply Now <FaExternalLinkAlt />
                      </a>
                    ) : (
                      <a 
                        href={`mailto:${selectedOpportunity.contact.email}`}
                        className="internship-opportunities-modal-application-link"
                      >
                        Contact to Apply <FaExternalLinkAlt />
                      </a>
                    )}
                  </div>
                ) : selectedOpportunity.applicationStatus === 'coming-soon' ? (
                  <div className="internship-opportunities-modal-application">
                    <p className="internship-opportunities-modal-coming-soon">
                      Applications coming soon! Contact {selectedOpportunity.contact.name} for more information.
                    </p>
                  </div>
                ) : (
                  <div className="internship-opportunities-modal-application">
                    <p className="internship-opportunities-modal-closed">
                      Applications are currently closed. Contact {selectedOpportunity.contact.name} for future opportunities.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InternshipOpportunities; 